/**
 * Human-facing label for an organization role enum value
 * (`ADMINISTRATOR` → `Administrator`). Centralized so every list, dropdown, and
 * badge capitalizes roles the same way.
 */
export function roleLabel(role: string): string {
  return role.charAt(0).toUpperCase() + role.slice(1).toLowerCase();
}
